module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/manage/qualification/qualification.component.html
// module id = ./src/app/Pages/manage/qualification/qualification.component.html
// module chunks = main